import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';
import { HttpClient } from '@angular/common/http';
import { Jobs } from 'app/shared/models/jobs.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  @ViewChild('vform') validationForm: FormGroup;
  referenceForm: FormGroup;
  jobsForm: FormGroup;
  fileData: File
  jobsFormSubmitted: boolean = false;
  selectedSkill: string[] = [];
  tagsList = []
  skillId = '6319d3595ab9e462a96cfb06'
  teamList = []
  selectedTeam: string[] = [];
  ipAddress: any
  currentUrl: any
  jobs_id: any
  jobs_data: any
  jobs_model = new Jobs()
  isEdit: boolean = false
  referenceList = []
  selectedRef: string[] = [];
  reference_id: any
  reference_model = {
    refId: '',
    name: '',
    links: '',
    description: '',
    IP: '',
    notes: '',
    admin_notes: ''
  }
  jobModel:any = {
    name: '',
    skills: [],
    team: [],
    projectbudget: '',
    rate: '',
    engage_tags:'',
    IP: '',
    description: '',
    references: [],
    notes: '',
    admin_notes: '',
    alert_notes: '',
    Communication: '',
    sprints: '',
    mom: '',
    dmsfrs: '',
    kpi: '',
    reports: '',
    workdairy: '',
    bitbucket: '',
    demo: '',
    qa: '',
    crequest: '',
    hunting_by: [],
    farming_by: [],
    source: '',
    technology: '',
    channel: '',
    isalert: '',
    priority: '',
    status: '',
    feature:'',
    workon:''
  }

  sourceList = [];
  source_tagcat_id = '63ef44bb5fb91668b7f123ba'
  source_name: any = 'upwork'
  selected_source = '63ef45065fb91668b7f123c3'

  channelList = []
  channel_id_upwork = '63f89955c3648e0879c3e068'
  channel_id_fiverr = '63f89982c3648e0879c3e06f'
  channel_id_direct = '63f899a5c3648e0879c3e076'
  selected_channel: any

  selectedTechnology = null
  technology_catId = '6319d5025ab9e462a96cfbba'
  technology_List = []

  usersList: []
  selectedHuntingBy: string[] = [];
  selectedFarmingBy: string[] = [];

  alert_list = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' },
  ]
  alert_event = 'no'

  engage_tagcat_id = '66cc36c9866da48baa275811'
  engage_tags_list = []
  selected_engage_tags:any = null
  selectedUploadType:any
  selectedImage: File | null = null;
  selectedImages: File[] = [];
  jobType_list=[
    {name:'Contract',id:'65264bf30af5538a9d4094a4'},
    {name:'Project',id:'644a5c52af0db342c32eeaf8'},
    {name:'Product',id:'644a5c84af0db342c32eeb02'},
  ]
  selected_job_type =null
  current_type:any
  project_source_cat_id = '685970b6de9510031e95875e'
  project_tags_tagcat_id ='685971ad7bf67c03258f6740'
  project_source_list = []
  project_tags_list = []
  base_url = environment.apiUrls.s3MediaUrl
  constructor(private formBuilder: FormBuilder, private http: HttpClient,
    public toastr: ToastrService, private activerouter: ActivatedRoute,
    public apiService: ApiService, private route: Router,
    private modalService: NgbModal,) {
    this.currentUrl = this.activerouter.snapshot.routeConfig.path
    this.activerouter.paramMap.subscribe(params => {
      this.jobs_id = params.get('id');
    })
    this.activerouter.queryParams
      .subscribe((params: any) => {
      this.current_type = params['type'];
      if(this.current_type === 'project'){
        this.selected_job_type = this.jobType_list[1].id
        this.jobModel.workon = this.selected_job_type
        this.getProjectSource()
        this.getProjectTags()
        this.selected_source = null

      }    
    })
  }

  ngOnInit() {
    if (this.currentUrl == 'edit/:id' && this.jobs_id) {
      this.getJobsById()
    }

    this.getSkillTagByCategory()
    this.getTeamList()
    this.jobsForm = this.formBuilder.group({
      name: ['', Validators.required],
      skills: ['',],
      team: ['',],
      projectbudget: ['',],
      rate: ['',],
      IP: ['',],
      description: ['',],
      references: ['',],
      Communication: ['',],
      sprints: ['',],
      mom: ['',],
      dmsfrs: ['',],
      kpi: ['',],
      reports: ['',],
      workdairy: ['',],
      bitbucket: ['',],
      demo: ['',],
      qa: ['',],
      crequest: ['',],
      alert_notes: ['',],
      notes: ['',],
      admin_notes: ['',],
      feature: ['',],
    })
    this.referenceForm = this.formBuilder.group({
      name: ['',],
      links: ['',],
      description: ['',],
      IP: ['',],
      notes: ['',],
      admin_notes: ['',]
    })
    this.getSource()
    this.getTechnologyList()
    this.getUsers()
    this.getEngageList()
  }
  get rf() {
    return this.jobsForm.controls;
  }

  getJobsById() {
    this.apiService.getJobsById(this.jobs_id).subscribe((res: any) => {
      for (let item of res?.data) {
        this.jobs_model = item
        this.jobModel.image = item?.image
        if(item?.workon[0]?._id){
          this.selected_job_type = item?.workon[0]?._id
        }
        
      }
      // console.log('job =>>',this.jobs_model)
      this.jobModel.name = this.jobs_model?.name
      this.jobModel.projectbudget = this.jobs_model?.projectbudget
      this.jobModel.IP = this.jobs_model?.IP
      this.jobModel.description = this.jobs_model?.description
      this.jobModel.Communication = this.jobs_model?.Communication
      this.jobModel.bitbucket = this.jobs_model?.bitbucket
      this.jobModel.crequest = this.jobs_model?.crequest
      this.jobModel.demo = this.jobs_model?.demo
      this.jobModel.dmsfrs = this.jobs_model?.dmsfrs
      this.jobModel.kpi = this.jobs_model?.kpi
      this.jobModel.mom = this.jobs_model?.mom
      this.jobModel.qa = this.jobs_model?.qa
      this.jobModel.reports = this.jobs_model?.reports
      this.jobModel.sprints = this.jobs_model?.sprints
      this.jobModel.workdairy = this.jobs_model?.workdairy
      this.alert_event = this.jobs_model?.isalert

      this.jobModel.notes = this.jobs_model?.notes
      this.jobModel.admin_notes = this.jobs_model?.admin_notes
      this.jobModel.alert_notes = this.jobs_model?.alert_notes
      this.jobModel.isalert = this.jobs_model?.isalert
      this.selectedSkill = this.jobs_model?.skills?.map((item) => item?._id)
      this.jobModel.skills = this.selectedSkill

      this.selectedHuntingBy = this.jobs_model?.hunting_by?.map((item) => item?._id)
      this.jobModel.hunting_by = this.selectedHuntingBy

      this.selectedFarmingBy = this.jobs_model?.farming_by?.map((item) => item?._id)

      this.jobModel.farming_by = this.selectedFarmingBy

      this.selectedTechnology = this.jobs_model?.technology[0]?._id
      this.jobModel.technology = this.selectedTechnology

      this.selected_channel = this.jobs_model?.channel?._id
      this.jobModel.channel = this.selected_channel

      this.selected_source = this.jobs_model?.source[0]?._id
      this.jobModel.priority = this.jobs_model?.priority[0]?._id
      this.jobModel.status = this.jobs_model?.status[0]?._id
      this.jobModel.rate = this.jobs_model?.rate
      if (this.jobs_model?.engage_tags) {
        this.selected_engage_tags = this.jobs_model?.engage_tags[0]?._id
        this.jobModel.engage_tags = this.selected_engage_tags
      }
      
      if (this.jobs_model?.references?.length > 0) {
        this.referenceList = this.jobs_model?.references?.map((item) => item)
        this.selectedRef = this.referenceList?.map((item) => item?._id)
        // this.jobModel.references=this.selectedRef
      }
      if (this.jobs_id) {
        if (this.source_name == 'upwork') {
          this.getChannelList(this.channel_id_upwork, this.selectedTechnology)
        }
        else if (this.source_name == 'fiverrr') {
          this.getChannelList(this.channel_id_fiverr, this.selectedTechnology)
        }
        else if (this.source_name == 'direct') {
          this.getChannelList(this.channel_id_direct, this.selectedTechnology)
        }
      }
      this.jobModel.description = this.jobs_model?.description
      this.jobModel.feature = this.jobs_model?.feature

      
      if(this.jobModel.image){
        this.selectedUploadType = 'single'
      }
    })
  }
  selectAlert(event) {
    this.alert_event
    this.jobModel.isalert = this.alert_event
  }

  getRefId(event) {
    if (!this.jobs_id && this.currentUrl == 'add') {
      this.selectedRef
      this.jobModel.references = event
    }
    if (this.jobs_id && this.currentUrl == 'edit/:id') {
      this.jobModel.references = event
      let data = this.jobModel.references.filter(obj => !('_id' in obj));
      if (data) {
        this.jobModel.references = data
        const newValues = event.filter(value => !this.jobModel.references.some(obj => obj._id === value._id))
        this.jobModel.references.push(...newValues)
      }
    }
  }
  getSkillTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.tagsList = res.data
    })
  }
  getTagsId(event: any) {
    this.selectedSkill
    if (this.jobs_id) {
      this.jobModel.skills = this.selectedSkill
    }
  }
  getTeamList() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.teamList = res.items
    })
  }
  getTeamId(event: any) {
    this.selectedTeam
    if (this.jobs_id) {
      this.jobModel.team = this.selectedTeam
    }
  }
  getSource() {
    this.apiService.getTagByTagCatgoryId(this.source_tagcat_id).subscribe((res: any) => {
      this.sourceList = res.data
    })
  }
  getProjectSource() {
    this.apiService.getTagByTagCatgoryId(this.project_source_cat_id).subscribe((res: any) => {
      this.project_source_list = res.data
    })
  }
  getProjectTags() {
    this.apiService.getTagByTagCatgoryId(this.project_tags_tagcat_id).subscribe((res: any) => {
      this.project_tags_list = res.data
    })
  }
  getSourceId(event: any) {
    this.source_name = event.name
    this.selected_source
    if (this.jobs_id) {
      this.jobModel.source = this.selected_source
    }
    if (this.source_name == 'upwork') {
      this.getChannelList(this.channel_id_upwork, this.selectedTechnology)
    }
    else if (this.source_name == 'fiverrr') {
      this.getChannelList(this.channel_id_fiverr, this.selectedTechnology)
    }
    else if (this.source_name == 'direct') {
      this.getChannelList(this.channel_id_direct, this.selectedTechnology)
    }

  }
  getChannelList(id, tech_id) {
    this.apiService.getChannelsByCategory(id, tech_id).subscribe((res: any) => {
      this.channelList = res.data
    })
  }
  getChangeChannelId(event) {
    this.jobModel.channel = this.selected_channel
  }
  getTechnologyList() {
    this.apiService.getTagByTagCatgoryId(this.technology_catId).subscribe((res: any) => {
      this.technology_List = res.data.slice(0, 4)
    })
  }
  getTechnologyId(event) {
    this.selectedTechnology
    if (this.source_name == 'upwork') {
      this.getChannelList(this.channel_id_upwork, this.selectedTechnology)
    }
    else if (this.source_name == 'fiverrr') {
      this.getChannelList(this.channel_id_fiverr, this.selectedTechnology)
    }
    else if (this.source_name == 'direct') {
      this.getChannelList(this.channel_id_direct, this.selectedTechnology)
    }
    if (this.jobs_id) {
      this.jobModel.technology = this.selectedTechnology
    }
  }
  getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
    })
  }
  getHuntId(event: any) {
    this.selectedHuntingBy
    if (this.jobs_id) {
      this.jobModel.hunting_by = this.selectedHuntingBy
    }
  }
   getEngageList() {
    this.apiService.getTagByTagCatgoryId(this.engage_tagcat_id).subscribe((res: any) => {
      this.engage_tags_list = res.data
    })
  }
  getEngageId(event) {
    this.selected_engage_tags
    if (this.jobs_id) {
      this.jobModel.engage_tags = this.selected_engage_tags
    }
  }
  getFarmId(event: any) {
    this.selectedFarmingBy
    if (this.jobs_id) {
      this.jobModel.farming_by = this.selectedFarmingBy
    }
  }
  submit() {
    let body = {
      name: this.jobsForm.value.name,
      skills: this.selectedSkill,
      projectbudget: this.jobsForm.value.projectbudget,
      references: this.jobModel.references,
      isalert: this.alert_event,
      hunting_by: this.selectedHuntingBy,
      farming_by: this.selectedFarmingBy,
      status: '6428038677a2ab2fb559dc36',// current status
      priority: '6428043d77a2ab2fb559dcd9',// normal priority
      source: this.selected_source,
      technology: this.selectedTechnology,
      channel: this.selected_channel,
      alert_notes: this.jobsForm.value.alert_notes,
      notes: this.jobsForm.value.notes,
      admin_notes: this.jobsForm.value.admin_notes,
      rate: this.jobsForm.value.rate,
      engage_tags: this.selected_engage_tags,
      description: this.jobsForm.value.description,
      feature: this.jobsForm.value.feature,
      workon: this.jobModel.workon,
      // Communication: this.jobsForm.value.Communication,
      // sprints: this.jobsForm.value.sprints,
      // mom: this.jobsForm.value.mom,
      // dmsfrs: this.jobsForm.value.dmsfrs,
      // kpi: this.jobsForm.value.kpi,
      // reports: this.jobsForm.value.reports,
      // workdairy: this.jobsForm.value.workdairy,
      // bitbucket: this.jobsForm.value.bitbucket,
      // demo:this.jobsForm.value.demo ,
      // qa: this.jobsForm.value.qa,
      // crequest:this.jobsForm.value.crequest ,
    }
    if (this.currentUrl == 'add') {
      // console.log('body', body)
      this.apiService.createJob(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.jobs_id = res?.data?._id
          if (this.selectedImage && this.selectedImage !==null || this.selectedImage !==undefined) this.profileImageUpload()
          if(this.selectedImages && this.selectedImages !==null || this.selectedImages !==undefined) this.multiImageUpload()


          // console.log('job create res', res)
          this.toastr.success('Job created successfully')
          // this.route.navigate(['/jobs/list'])
          window.history.back()
        }
        else { this.toastr.error(res.error) }
      })
      this.jobsFormSubmitted = true;
      if (this.jobsForm.invalid) {
        return;
      }
    }
    if (this.currentUrl == 'edit/:id' && this.jobs_id) {
      this.jobModel.source = this.selected_source
      // if(this.jobModel.priority =='' && this.jobModel.status ==''){
      // this.jobModel.priority='6428043d77a2ab2fb559dcd9'// normal job_priority
      this.jobModel.status = '6428038677a2ab2fb559dc36' // current job_status
      // }
      // console.log('update',this.jobModel)
      this.jobModel.workon = this.selected_job_type
      this.apiService.updateJob(this.jobs_id, this.jobModel).subscribe((res: any) => {
        if (res.statusCode == 200) {
          if (this.selectedImage && this.selectedImage !==null || this.selectedImage !==undefined) this.profileImageUpload()
          if(this.selectedImages && this.selectedImages !==null || this.selectedImages !==undefined) this.multiImageUpload()

          this.toastr.success('Job update successfully')
          // this.route.navigate(['/jobs/list'])
          window.history.back()
        }
        else { this.toastr.error(res.error) }
      })
    }

  }
  back() {
    // this.route.navigate(['/jobs/list'])
    window.history.back()

  }
  openModal(content) {
    this.reference_model.IP = this.ipAddress
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submitRef() {

    this.referenceForm = this.formBuilder.group(this.reference_model);
    this.referenceList.push(this.referenceForm.value)
    this.referenceList = this.referenceList.map(item => item)
    this.referenceForm.reset(this.reference_model);
    this.modalService.dismissAll()
  }

  editItem(data, content) {
    this.reference_id = data._id
    this.reference_model.refId = this.reference_id
    this.reference_model.name = data.name
    this.reference_model.links = data.links
    this.reference_model.description = data.description
    this.reference_model.notes = data.notes
    this.reference_model.admin_notes = data.admin_notes
    this.reference_model.IP = data.IP
    this.jobs_id = data.job_id
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateRef() {
    let body = {
      references: [this.reference_model]
    }
    if (this.reference_id !== '') {
      this.apiService.updateJob(this.jobs_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Reference update successfully')
          this.getJobsById()
          this.modalService.dismissAll()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  deleteRef(password) {
    this.apiService.refDelete(this.reference_id, password).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getJobsById()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }

    })
  }

  // ================== Delete Alert ========================
  confirmDelete(id: any) {
    this.reference_id = id
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteRef(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  onSingleFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.selectedImage = target.files[0];
      this.selectedImages = []; // Clear multiple images
  
      // Read and preview image
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedImage = e.target.result;
      };
      reader.readAsDataURL(this.selectedImage);
    }
  }
  

  // For handling file selection for multiple images
  onMultipleFilesSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      this.selectedImages = Array.from(target.files);
      this.selectedImage = null; // Clear single image

    }

  }

  // Handle switching between single and multiple upload
 switchUploadType(type: 'single' | 'multiple'): void {
    this.selectedUploadType = type;
  }
  // getImagePreview(image: File): string {
  //   return URL.createObjectURL(image);
  // }
  multiImageUpload() {
    const formData = new FormData();
    if (this.selectedImages) {
      for (const image of this.selectedImages) {
        formData.append('photos', image);
         this.apiService.uploadJobMultiImage(this.jobs_id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Multiple images uploaded successfully')
        }
        else {
          this.toastr.error(res.error)
        }
      })
      }
     
    }

  }
  profileImageUpload() {
    const formData = new FormData();
    if (this.selectedImage) {
      console.log('this.selectedImage',this.selectedImage)
        formData.append('image', this.selectedImage);
        this.apiService.uploadJobImage(this.jobs_id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Image uploaded successfully')
        }
        else {
          this.toastr.error(res.error)
        }
      })
      }
      
    }
    selectTypeId(event){
      this.jobModel.workon = this.selected_job_type
      console.log(this.jobModel.workon)
    }
    inlineAddupdateBody(data ,prop) {
      if (prop == 'alert_notes') {
        this.jobModel.alert_notes =data
      }
      else if (prop == 'notes') {
        this.jobModel.notes =data
      }
      else if(prop == 'admin_notes') {
        this.jobModel.admin_notes =data
      }
      else if(prop == 'description') {
        this.jobModel.description =data
      }
      else if(prop == 'feature') {
        this.jobModel.feature =data
      }
  
    }
    setFocus(event,prop) {
      event.html
      if (prop == 'alert_notes') {
        if(this.jobs_id)this.jobModel.alert_notes =event.html
        this.jobsForm.value.alert_notes =event.html
      }
      else if (prop == 'notes') {
        if(this.jobs_id)this.jobModel.notes =event.html
        this.jobsForm.value.notes =event.html
      }
      else if(prop == 'admin_notes') {
        if(this.jobs_id)this.jobModel.admin_notes =event.html
        this.jobsForm.value.admin_notes =event.html
        
      }
      else if(prop == 'description') {
        if(this.jobs_id)this.jobModel.description =event.html
        this.jobsForm.value.description =event.html

      }
      else if(prop == 'feature') {
        if(this.jobs_id)this.jobModel.feature =event.html
        this.jobsForm.value.feature =event.html

      }
    }
}
